import { FC, ReactNode, useContext, useEffect } from "react";
import { useSelector } from "react-redux";

import { RootState, useAppDispatch } from "store";
import { refreshToken } from "store/actions/authentication";

import { isEmpty } from "lodash-es";

import { OAuthContext } from "./OAuthProvider";

const RefreshTokenProvider: FC<{ children?: ReactNode }> = props => {
  const { children } = props;
  const dispatch = useAppDispatch();

  const { clientId } = useContext(OAuthContext);
  const isLoading = useSelector((state: RootState) => state.authentication.refreshingToken);
  const token = useSelector((state: RootState) => state.authentication.accessToken?.access_token);

  useEffect(() => {
    if (isEmpty(token)) {
      dispatch(refreshToken(clientId));
    }
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  return isLoading ? null : <>{children}</>;
};
export default RefreshTokenProvider;
